import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs'
import { Globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class ProductoService {

  constructor(
    private httpClient: HttpClient, 
		private globals: Globals,
  ) { }

	categoriaListado( parametros?:any ): Observable<any>{

		return this.httpClient.get( this.globals.configuracion.rootApiRestFull + "?componente=producto&modulo=categorias-catalogo-web" );
	}

	marcasListado( parametros?:any ): Observable<any>{

		return this.httpClient.get( this.globals.configuracion.rootApiRestFull + "?componente=producto&modulo=marcas-catalogo-web&categoria=" + parametros.categoria );
	}

	modelosListado( parametros?:any ): Observable<any>{
		let urlParams = '';
		if( parametros.marca ){
			urlParams += "marca=" + parametros.marca;
		}
		if( parametros.categoria ){
			urlParams += "categoria=" + parametros.categoria;
		}

		return this.httpClient.get( this.globals.configuracion.rootApiRestFull + "?componente=producto&modulo=modelos-catalogo-web&" + urlParams );
	}

	tagsListado( parametros?:any ): Observable<any>{
		let urlParams = '';
		if( parametros.categoria ){
			urlParams += "categoria=" + parametros.categoria;
		}

		return this.httpClient.get( this.globals.configuracion.rootApiRestFull + "?componente=producto&modulo=tags-catalogo-web&" + urlParams );
	}

	productoListado( parametros?:any ): Observable<any>{
		const form = new FormData();
		if ( parametros ) {
			for ( var key in parametros ) {
				if( key == 'modelos' ){
					for( let x = 0; x < parametros[key].length; x++ ){
						form.append("modelos[]", parametros[key][x]);
					}
				}else{
					if( key == 'tags' ){
						for( let x = 0; x < parametros[key].length; x++ ){
							form.append("tags[]", parametros[key][x]);
						}
					}else{
						form.append(key, parametros[key]);
					}
				}
			}
		}

		return this.httpClient.post( this.globals.configuracion.rootApiRestFull + "?componente=producto&modulo=producto-listado-catalogo-web", form );
	}
	getRegistrosPaginados(page: number, parametros?:any ): Observable<any> {
		const form = new FormData();
		if ( parametros ) {
			for ( var key in parametros ) {
				if( key == 'modelos' ){
					for( let x = 0; x < parametros[key].length; x++ ){
						form.append("modelos[]", parametros[key][x]);
					}
				}else{
					if( key == 'tags' ){
						for( let x = 0; x < parametros[key].length; x++ ){
							form.append("tags[]", parametros[key][x]);
						}
					}else{
						form.append(key, parametros[key]);
					}
				}
			}
		}
		// Supongamos que la API acepta un parámetro "page" para paginar los resultados
		// Puedes ajustar la URL y los parámetros según cómo esté implementada tu API
		return this.httpClient.post( this.globals.configuracion.rootApiRestFull + "?componente=producto&modulo=producto-listado-catalogo-web", form );
	}
	productoListadoPDF( parametros?:any ): Observable<any>{
		const form = new FormData();
		if ( parametros ) {
			for ( var key in parametros ) {
				if( key == 'modelos' ){
					for( let x = 0; x < parametros[key].length; x++ ){
						form.append("modelos[]", parametros[key][x]);
					}
				}else{
					if( key == 'tags' ){
						for( let x = 0; x < parametros[key].length; x++ ){
							form.append("tags[]", parametros[key][x]);
						}
					}else{
						form.append(key, parametros[key]);
					}
				}
			}
		}

		return this.httpClient.post( this.globals.configuracion.rootApiRestFull + "?componente=producto&modulo=producto-listado-catalogo-web-pdf",form );
	}

	productoDetalle( parametros?:any ): Observable<any>{
		const form = new FormData();
		if ( parametros ) {
			for ( var key in parametros ) {
				form.append(key, parametros[key]);
			}
		}

		return this.httpClient.post( this.globals.configuracion.rootApiRestFull + "?componente=producto&modulo=producto-detalle-catalogo-web", form );
	}

	productoAgregarAlCarro( parametros?:any ): Observable<any>{
		const form = new FormData();
		if ( parametros ) {
			for ( var key in parametros ) {
				form.append(key, parametros[key]);
			}
		}
    
		if( this.globals.configuracion.dataToken.token != null ){
			form.append("token", this.globals.configuracion.dataToken.token);
		}

		return this.httpClient.post( this.globals.configuracion.rootApiRestFull + "?componente=producto&modulo=producto-agregar-al-carro", form );
	}

	cotizacionGuardar( parametros?:any ): Observable<any>{
		const form = new FormData();
		if ( parametros ) {
			for ( var key in parametros ) {
				if( key == "productos" ){
					for( let x = 0; x < parametros[key].length; x++ ){
						form.append( "productos[" + x + "][stockid]", parametros[key][x].stockid );
						form.append( "productos[" + x + "][precio]", parametros[key][x].precio_final );
						form.append( "productos[" + x + "][taxrate]", parametros[key][x].taxrate );
						form.append( "productos[" + x + "][cantidad]", parametros[key][x].cantidad );
					}
				}else{
					form.append(key, parametros[key]);
				}
			}
		}
    
		if( this.globals.configuracion.dataToken.token != null ){
			form.append("token", this.globals.configuracion.dataToken.token);
		}

		return this.httpClient.post( this.globals.configuracion.rootApiRestFull + "?componente=cotizaciones&modulo=cotizacion-guardar", form );
	}

	productosCheckToken( parametros?:any ): Observable<any>{
		const form = new FormData();

		form.append("typeabbrev", this.globals.configuracion.front.typeabbrev);
		if( this.globals.configuracion.dataToken.token != null ){
			form.append("token", this.globals.configuracion.dataToken.token);
		}

		return this.httpClient.post( this.globals.configuracion.rootApiRestFull + "?componente=producto&modulo=producto-check-token", form );
	}

	cotizacionesCliente( parametros?:any ): Observable<any>{
		const form = new FormData();

		if( this.globals.configuracion.dataToken.token != null ){
			form.append("token", this.globals.configuracion.dataToken.token);
		}

		return this.httpClient.post( this.globals.configuracion.rootApiRestFull + "?componente=cotizaciones&modulo=cotizaciones-cliente", form );
	}

	cotizacionCarrito( parametros?:any ): Observable<any>{
		const form = new FormData();
		if ( parametros ) {
			for ( var key in parametros ) {
				form.append(key, parametros[key]);
			}
		}

		if( this.globals.configuracion.dataToken.token != null ){
			form.append("token", this.globals.configuracion.dataToken.token);
		}

		return this.httpClient.post( this.globals.configuracion.rootApiRestFull + "?componente=cotizaciones&modulo=cotizacion-carrito", form );
	}

}
